import { useMemo, useState } from 'react'

import { EyeIcon, EyeOffIcon } from '@twistopayments/design-system/icons/inline'

import type { InputProps } from '../../atoms/input'
import { Input } from '../../atoms/input'

type Props = { name: string } & Omit<InputProps, 'type'>

export const PasswordInput = ({
  error = false,
  focused = false,
  ...props
}: Props) => {
  const [passwordShow, changePasswordShow] = useState(false)
  const other = { ...props, error, focused }

  const EndAdornment = useMemo(
    () => {
      const Icon = passwordShow ? EyeOffIcon : EyeIcon

      return <Icon color="gray" size="24" onClick={() => changePasswordShow(!passwordShow)} />
    },
    [passwordShow]
  )

  return (
    <Input
      data-testid="password-input"
      endAdornment={EndAdornment}
      type={passwordShow ? 'text' : 'password'}
      {...other}
    />
  )
}
